import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Errors, Form } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import LayoutContainer from '../../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import ArrowButton from '../../../common/button-arrow';
import { convertPoints, savePpcManualLoad } from '../../../../actions/ppc';
import RequiredInput from '../../../common/form/elements/required-input';
import { isRrfFormValid } from '../../../../utils/commonFunctions';
import t from '../../../../data/translations';

class PpcLoadForm extends Component {
  onSubmit = (payLoad) => {
    const { dispatch, userId } = this.props;

    dispatch(actions.submitFields('deep.admin_ppc.management.manual_load', savePpcManualLoad(userId, payLoad)));
  };

  convertPointsToEuros = (points) => {
    const { dispatch, links } = this.props;

    dispatch(convertPoints(points, links['convert-to-value'], 'deep.admin_ppc.management.manual_load.value'));
  };

  render() {
    return (
      <LayoutContainer>
        <Form
          model="deep.admin_ppc.management.manual_load"
          onSubmit={this.onSubmit}
        >
          <Errors className="errors" component={ErrorMessages} model="deep.admin_ppc.management.manual_load"/>
          <Row>
            <Col lg={12}>
              <RequiredInput
                controlId="loadPoints"
                debounce={200}
                label="Load value (points)"
                model=".points"
                onChange={this.convertPointsToEuros}
                placeholder="e.g. 200"
              />
              <RequiredInput
                controlId="loadValue"
                label={`Load value (${t('currency')})`}
                model=".value"
                placeholder="e.g. 20"
                readOnly
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton
                className="float-end"
                disabled={this.props.form.$form.pending || !isRrfFormValid(this.props.form, { async: false })}
              >
                Place order
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  form: state.deep.forms.admin_ppc.management.manual_load,
  links: state.ppc.loadLinks
});

export default connect(mapStateToProps)(PpcLoadForm);
